import React from 'react';
import PropTypes from 'prop-types';
import { TeamWrapper, TeamLogo, TeamName } from './styles';
//import flagImg from '../../utils/assets/flag.png';

const flagImg = 'https://images2.gazzettaobjects.it/matchcenter/static/placeholder/placeholder-shield.svg';

const TeamLabel = ({
  label, color, size, weight, marginLeft, withCursor, image, font, isFlag, isLoserCrossed
}) => (
  <TeamWrapper withCursor={withCursor}>
    {image ?
      (<TeamLogo
        src={image}
        isFlag={isFlag}
        onError={(e) => {
          e.target.src = flagImg;
        }}
      />)
      :
      <TeamLogo
        src=""
      />
    }
    <TeamName
      marginLeft={marginLeft}
      color={color}
      size={size}
      weight={weight}
      font={font}
      isLoserCrossed={isLoserCrossed}
    >
      {label}
    </TeamName>
  </TeamWrapper>
);

TeamLabel.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  marginLeft: PropTypes.number,
  withCursor: PropTypes.bool,
  image: PropTypes.any,
  font: PropTypes.any,
  isFlag: PropTypes.bool,
  isLoserCrossed: PropTypes.bool,
};

export default TeamLabel;
